import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const MobileAppointmentList = ({ appointments, onAppointmentClick }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'confirmed':
        return 'bg-success/10 border-success text-success';
      case 'pending':
        return 'bg-warning/10 border-warning text-warning';
      case 'cancelled':
        return 'bg-muted border-border text-muted-foreground';
      case 'completed':
        return 'bg-primary/10 border-primary text-primary';
      default:
        return 'bg-muted border-border text-foreground';
    }
  };

  const groupedAppointments = appointments?.reduce((acc, apt) => {
    const date = new Date(apt.startTime)?.toLocaleDateString('en-US', { 
      weekday: 'long', 
      month: 'long', 
      day: 'numeric' 
    });
    if (!acc?.[date]) {
      acc[date] = [];
    }
    acc?.[date]?.push(apt);
    return acc;
  }, {});

  return (
    <div className="lg:hidden space-y-6 p-4">
      {Object.entries(groupedAppointments)?.map(([date, dayAppointments]) => (
        <div key={date}>
          <h3 className="text-lg font-semibold text-foreground mb-3 sticky top-0 bg-background py-2">
            {date}
          </h3>
          <div className="space-y-3">
            {dayAppointments?.map((apt) => (
              <button
                key={apt?.id}
                onClick={() => onAppointmentClick(apt)}
                className={`w-full p-4 rounded-lg border text-left transition-smooth hover:shadow-md ${getStatusColor(apt?.status)}`}
              >
                <div className="flex items-start gap-3">
                  <Image
                    src={apt?.patientAvatar}
                    alt={apt?.patientAvatarAlt}
                    className="w-12 h-12 rounded-full object-cover flex-shrink-0"
                  />
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2 mb-2">
                      <h4 className="font-semibold text-base truncate">{apt?.patientName}</h4>
                      <span className="text-sm font-medium whitespace-nowrap">
                        {new Date(apt.startTime)?.toLocaleTimeString('en-US', { 
                          hour: 'numeric', 
                          minute: '2-digit' 
                        })}
                      </span>
                    </div>
                    <p className="text-sm opacity-90 truncate mb-2">{apt?.type}</p>
                    <div className="flex items-center gap-4 text-xs">
                      <span className="flex items-center gap-1">
                        <Icon name="User" size={12} />
                        {apt?.providerName}
                      </span>
                      <span className="flex items-center gap-1">
                        <Icon name="Clock" size={12} />
                        {apt?.duration} min
                      </span>
                    </div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MobileAppointmentList;